import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import { alankaramDataAtom } from '../../state';

export default function Modal({ open, onClose, children }: any) {
  const cancelButtonRef = useRef(null);
  const AlankaramData = useRecoilValue(alankaramDataAtom);

  return (
    <Transition show={open} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50"
        initialFocus={cancelButtonRef}
        static
        open={open}
        onClose={() => { }}
        dir="ltr"
      >
        <div className="min-h-full text-center md:p-5">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 custom_class_background" style={{ backgroundImage: `url(${AlankaramData?.backgroundImage})` }} />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="min-w-content relative inline-block !max-w-full align-middle transition-all text-left rtl:text-right" style={{ boxShadow: "0 20px 40px rgba(0, 0, 0, 0.5)"}}>
              {/* <button
                onClick={onClose}
                aria-label="Close panel"
                ref={cancelButtonRef}
                className="absolute top-4 z-[60] inline-block outline-none focus:outline-0 right-4 rtl:left-4 lg:hidden"
              >
                <span className="sr-only">close</span>
                <CloseIcon className="h-4 w-4" />
              </button> */}
              {children}
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
